import { formatPhoneNumber } from "@/components/Forms/schema/personSchema.ts";
import { z } from "zod";

export const phoneNumberSchema = z.object({
    idUUID: z.string(),
    phoneType: z.string().optional().nullable(),
    phoneNumber: z
        .string()
        .optional()
        .nullable()
        .transform((val) => formatPhoneNumber(val)),
    extension: z.string().optional().nullable(),
    primary: z.string().optional().nullable(),
    oK2Call: z.string().optional().nullable(),
    altContactType: z.string().optional().nullable(),
    altContactName: z.string().optional().nullable(),
});
